import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Arrow Right"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-arrow-right',
    templateUrl: './icon-arrow-right.component.html',
    styleUrls: ['./icon-arrow-right.component.scss'],
    standalone: false
})
export class IconArrowRightComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
